import { render, staticRenderFns } from "./HomeB.vue?vue&type=template&id=ab348c56&scoped=true&"
import script from "./HomeB.vue?vue&type=script&lang=js&"
export * from "./HomeB.vue?vue&type=script&lang=js&"
import style0 from "./HomeB.vue?vue&type=style&index=0&id=ab348c56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab348c56",
  null
  
)

component.options.__file = "HomeB.vue"
export default component.exports